<script>
    import {onMount} from 'svelte'
    import {getResource} from '../service'
    export let permissions = []    
    export let resource_creator_id = null
    let visible = false
    
    function checkPermission(user){       
        if(permissions.length == 0){
            visible = false
            return
        }
        
        for(let permission of permissions){ //1           
            let target , action
            [target,action] = permission.split(".")            
            if(target in  user.permissions){//2
                let p = user.permissions[target]              
                if(action in p){//3
                    // console.log(p[action])
                    if(p[action] == 'ALL' || (p[action] == 'SELF' && user.id == resource_creator_id))
                    {//4
                        visible = true
                        break
                    }//4
                }//3
            }//2            
        } //1        
    }

    onMount(()=>{
        getResource('profile')
        .subscribe(p =>{
            p.then(data => {
                checkPermission(data)

            })
        })
    })




</script>
{#if visible}
    <slot></slot>
{/if}